export default function Empty() {
  return 'No projects match the selected filters.';
}
